import React from 'react';
import ReactMarkdown from 'react-markdown';
import { publicOffer } from '../data/legalDocs';
import './Legal.css';

function PublicOffer() {
  return (
    <div className="legal-page">
      <h1>Публичная оферта</h1>
      <div className="legal-content">
        <ReactMarkdown>{publicOffer}</ReactMarkdown>
      </div>
    </div>
  );
}

export default PublicOffer;